module.exports = __webpack_public_path__ + "static/jamstackdiagonal-2238369758f431ebca64300684b61d6d.png";